import { ArgumentError } from '../utils/errors';
import ImageUploadConfigModel from './imageUploadConfig';
import { fetcher } from '@weezevent/weezjs-core';

export default class UploadRequestConfigModel extends ImageUploadConfigModel {
    /**
     * POSTs to AWS S3 to upload template once the config is set
     */
    uploadFile(file) {
        // Sadly, fields is a method of BaseAPIModel, we must retrieve
        // the actual value from our underlying JSON object
        const {
            upload_config: { url, fields }
        } = this;

        if (!url || !fields) {
            throw new Error(`[Model][UploadRequest][upload] You should get a config first by calling .get or .getAll`);
        }

        let data = new FormData();

        Object.entries(fields).map(([key, value]) => data.append(key, value));

        // APparently AWS S3 does not like having 'key' after 'file'
        data.append('file', file);

        return fetch(url, {
            method: 'POST',
            headers: {
                contentType: 'multipart/form-data'
            },
            body: data
        }).then(() => {
            // 204 no content
            this.source = fields.key;
            this.file = file;
            this.process = 'attendee-import';
            return this;
        });
    }

    uploadConfig({ organizationId, eventId, datas = {}, name = '' }) {
        let url = `/ticket/organizations/${organizationId}/events/${eventId}/orders/import/config`;
        if (name) {
            url += `?name=${name}`;
        }
        return fetcher.post(url).then(({ response }) => {
            this.upload_config = response;
            this.data = datas;
            return this;
        });
    }

    static listUrl({ organizationId, eventId }) {
        if (!organizationId || !eventId) {
            throw new ArgumentError(`[Model][UploadRequest][getAll] organizationId and eventId are mandatory`);
        }

        return `/ticket/organizations/${organizationId}/events/${eventId}/import`;
    }
}
